import { useEffect } from 'react';

import { Route, Routes } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { useLogin } from 'hooks/useLogin';

import CreateFirstProject from './CreateFirstProject';
import RequestSubmitted from './RequestSubmitted';

const CreateFirstProjectView = () => {
  const navigate = useNavigate();
  const { mustInitiateProject } = useLogin();

  useEffect(() => {
    if (!mustInitiateProject) {
      navigate('/', { replace: true });
    }
  }, [mustInitiateProject]);

  return (
    <Routes>
      <Route path="/" element={<CreateFirstProject />} />
      <Route path="/request-submitted" element={<RequestSubmitted />} />
    </Routes>
  );
};

export default CreateFirstProjectView;
